import * as Yup from 'yup';

const newRegistro = {
    nome: '',
    dataRegistro: new Date().toISOString().split('T')[0],
    funcionario: null, // No frontend usamos 'funcionario', mas enviamos como 'responsavel' para o backend
    talhao: null,
    pragaDoenca: null,
    aplicacaoEstagio: null,
    tipoEscalaIncidencia: null,
    incidencia: '',
    escala: null,
    latitude: '',
    longitude: '',
    observacao: '',
    status: 0, // Status do controle - Padrão: DETECTADO (0-DETECTADO, 1-PLANEJADO, 2-EM_TRATAMENTO, 3-TRATADO, 4-CANCELADO)
};

const validation = Yup.object().shape({
    nome: Yup.string()
        .min(2, 'O campo deve ter no mínimo 2 caracteres')
        .max(120, 'Campo deve ter menos do que 120 caracteres')
        .required('Este campo é obrigatório'),
    dataRegistro: Yup.date()
        .typeError('Data inválida')
        .required('Este campo é obrigatório'),
    funcionario: Yup.object()
        .nullable()
        .required('Este campo é obrigatório'),
    talhao: Yup.object()
        .nullable()
        .required('Este campo é obrigatório'),
    pragaDoenca: Yup.object()
        .nullable()
        .required('Este campo é obrigatório'),
    tipoEscalaIncidencia: Yup.string()
        .nullable()
        .required('Este campo é obrigatório'),
    incidencia: Yup.number()
        .when('tipoEscalaIncidencia', {
            is: 'INCIDENCIA',
            then: Yup.number()
                .min(0, 'Valor mínimo é 0')
                .max(100, 'Valor máximo é 100')
                .required('Este campo é obrigatório'),
            otherwise: Yup.number().nullable()
        }),
    escala: Yup.number()
        .when('tipoEscalaIncidencia', {
            is: 'ESCALA',
            then: Yup.number()
                .min(1, 'Valor mínimo é 1')
                .max(5, 'Valor máximo é 5')
                .required('Este campo é obrigatório'),
            otherwise: Yup.number().nullable()
        }),
    status: Yup.number()
        .nullable()
        .required('Este campo é obrigatório')
        .oneOf([0, 1, 2, 3, 4], 'Status inválido'),
});

export const controlePragaDoenca = {
    newRegistro,
    validation
}
